import { Checkbox, Select, Typography } from 'antd';
import moment from 'moment';
import { IBestDataset } from '../../../../../../types/analytics';
import { DateFormat } from '../../../../../../utils/StaticVariable';
import DatePicker from '../../../../../../lib/MomentDatePicker';
import styles from '../../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface ScatterTableInputFormProps {
  datasets: IBestDataset[];
  previewDatasetId: string;
  onDatasetChange: (value: string) => void;
  categories: string[];
  variables: any[];
  tempVariable: any;
  onVariableChange: (value: any) => void;
  startDate: moment.Moment;
  endDate: moment.Moment;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  disabledStartDate: (date: any) => boolean;
  disabledEndDate: (date: any) => boolean;
  isForAllAnalytics: boolean;
  onCheckboxChange: () => void;
  isLoading: boolean;
  hasError: boolean;
  isOfflineDataset: boolean;
}

export default function ScatterTableInputForm({
  datasets,
  previewDatasetId,
  onDatasetChange,
  categories,
  variables,
  tempVariable,
  onVariableChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isForAllAnalytics,
  onCheckboxChange,
  isLoading,
  isOfflineDataset,
}: ScatterTableInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Dataset</Text>
        <Select
          id='Analytics-ScatterTable-Dataset_Input'
          value={previewDatasetId}
          onChange={onDatasetChange}
          placeholder='Select dataset'
          disabled={isLoading}
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.variableItem}`}>
        <Text>Variable</Text>
        <Select
          id='Analytics-ScatterTable-Variable_Input'
          placeholder='Select variable'
          onChange={onVariableChange}
          value={
            variables.length && tempVariable?.Index
              ? tempVariable?.Index
              : undefined
          }
          disabled={isLoading || isOfflineDataset}
        >
          {variables
            .filter((item: { Name: string }) => item.Name !== 'Time')
            .map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Analytics-StartDate_Input'
      >
        <Text>Start Date</Text>
        <DatePicker
          // id='Analytics-ScatterTable-StartDate_Input'
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isLoading || isOfflineDataset}
        />
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Analytics-EndDate_Input'
      >
        <Text>End Date</Text>
        <DatePicker
          // id='Analytics-ScatterTable-EndDate_Input'
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isLoading || isOfflineDataset}
        />
      </div>

      <div
        className={`${styles.formItem} ${styles.checkboxItem}`}
        data-testid='Analytics-Period-Checkbox'
      >
        <Checkbox
          disabled={isLoading || isOfflineDataset}
          checked={isForAllAnalytics}
          onChange={onCheckboxChange}
        />
        <Text onClick={onCheckboxChange} style={{ cursor: 'pointer' }}>
          Use this period for all analytics
        </Text>
      </div>
    </div>
  );
}
